








































































import VueOptions from '@utils/VueOptions'
import { Carousel, Slide } from 'vue-carousel'
import Gallery from '@ui/Gallery'

settings =
  name: 'Carousel'

  vue:
    components: { Carousel, Slide, Gallery }
    props: ['images', 'options', 'actions']

    data: ->
      galleryModal:
        show: false
        idx: 0

      isUploading: false
      filesToUpload: []
      navigationClicked: false

    computed:
      hasUploadSlot: -> !!@$slots.upload

      loop: ->
        return false unless @options?.loop?
        @options.loop

      autoplay: ->
        return false unless @options?.autoplay?
        @options.autoplay

      navigationEnabled: ->
        return true unless @options?.navigationEnabled?
        @options.navigationEnabled

      paginationEnabled: ->
        return false unless @options?.paginationEnabled?
        @options.paginationEnabled

      perPage: -> @options?.perPage || 4.25
      height: -> @options?.height || '150px'
      spaceBetweenSlides: -> @options?.spaceBetweenSlides || '10px'
      navigationPrevLabel: -> @options?.navigationPrevLabel || '<span class="flex items-center justify-center shadow-lg pr-1 w-8 h-8 rounded-full bg-white text-recess hover:bg-recess hover:text-white"><i class="fas fa-chevron-left text-lg"></i></span>'
      navigationNextLabel: -> @options?.navigationNextLabel || '<span class="flex items-center justify-center shadow-lg pl-1 w-8 h-8 rounded-full bg-white text-recess hover:bg-recess hover:text-white"><i class="fas fa-chevron-right text-lg"></i></span>'

      uploadEnabled: -> @hasUploadSlot || !!@uploadPath
      uploadPath: -> @options?.uploadPath
      acceptFormats: -> @options?.acceptFormats || 'image/*,image/heic'

      removeEnabled: -> @actions?.remove?
      displayGallery: -> 
        return true unless @options?.displayGallery?
        @options.displayGallery

    methods:
      hiOpenGalleryImage: (index) ->
        @galleryModal.idx = index
        @galleryModal.show = !@galleryModal.show if @displayGallery

      beforePhotoUpload: ->
        @isUploading = true

      onPhotoUploadSuccess: ->
        @isUploading = false

      onPhotoUploadError: ->
        @isUploading = false

      navigationClick: -> @navigationClicked = true

      hiCarousel: (event) ->
        if @navigationClicked
          event.stopPropagation()
          @navigationClicked = false

      addAttachment: (file) ->
        await @uploadFile(@uploadPath, file.file)
        @actions?.onUpload?()

export default VueOptions.vue settings
